import React, { useState, useEffect, useRef } from "react";
import TextInputModal from "../../../common/TextInputModal";
import { CheckBoxInput, SelectForm } from "../../../common/Buttons";
import { Divs } from "../../../common/StyledComponents";
import { FcCheckmark } from "react-icons/fc";
import ShipmentAdditionalServices from "../../../common/GlobalModals/Orders/ShipmentAdditionalServices";
import RowsInShipment from "../../../common/GlobalModals/Orders/editModal/RowsInShipment";
import {
  availableCountries,
  handleChangeOrdertypeGlobal,
  onChangeCheckBoxDeliveryGlobal,
  possibilityToAssignDeliveryAmount,
  renderTextInBlock,
  setCod,
  setCodAmount2,
  shipmentAdditionalServicesAttributesParams,
  shipment_type_setter,
  show_parcels,
  isWarehousePickupAddress,
  findOfficePickupAddress,
  shipmentToFormValues,
} from "../../../../helpers/OrdersFunctionsGlobal";
import { ClassicButton } from "../../../common/ButtonWithLoading";
import { useDispatch, useSelector } from "react-redux";
import { postOrderShipping } from "../../../../redux/Actions/orderAction";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { shipment_types_options } from "../../../../helpers/GlobalOptions";
import { antdMessageError } from "../../../../helpers/Utils";
import DalineSaskaita from "../../../common/GlobalModals/Orders/editModal/invoice/PopoverInvoiceButton";
import ShippmentTable from "../../../common/GlobalModals/Orders/editModal/Shippment/ShippmentTable";
import { FiAlertCircle } from "react-icons/fi";
import { Tooltip } from "antd";
import { shipmentTypeRules } from "../../../../helpers/ShipmentRules";
import { ButtonSecondary } from "../../../common";
import AntdConfirm from "../../../../helpers/AntdConfirm";
import {
  setCountriesOptions,
  setParcelTerminalsOptions,
  setPickupAddressesOptions,
} from "../../../../redux/Actions/options_action";
import { useCallback } from "react";
import SelectParcelTerminalInput from "../../../globals/SelectParcelTerminalInput";
import { setOrderInitialValue } from "../../../../utils/order";
import { IconCloseCircle } from "../../../Layout/Icons";
import Axios from "axios";

const defaultGeneral = {
  weight: 1,
  pack: 1,
  order_return: false,
  cod: false,
  cod_amount: 0,
  deliveryOnSaturday: false,
  delivery_same_day: false,
  sendingDocuments: false,
  who: "",
  deliveryTime: false,
  deliveryTimeHours: ["", ""],
  carrying: false,
  swap: false,
  lp_express_sizes: undefined,
  suppliers: undefined,
  delivery_after_18: false,
};
const defaultAddress = {
  parcel_terminal_id: undefined,
  firstname: "",
  lastname: "",
  postal_code: "",
  street: "",
  city: "",
  phone: "",
  other: "",
  comment: "",
};

export default function ShipmentComponentIndex({
  order_rows,
  id,
  id_order,
  remark,
  shipping_address,
  total_price,
  payment_module,
  carrier,
  onClose,
  order_invoices,
  order_cart_rules,
  billing_address,
  shipments,
  assigned_bills,
  cod,
  leasing_cod,
  leasing_advance,
  waiting_payments,
  order_shop_id,
  order_shop,
  callBackOnCreate = () => console.log("created"),
  pickup_address_id = null,
  orderRowsChange,
  form_type = "Order",
  total_shipping_tax_incl = 0,
  multiple,
  replaceShipment = null,
}) {
  const servicesKeywords = [
    "Uznešanas",
    "kandeteenus",
    "užnešimas",
    "81",
    "101",
    "90",
  ];
  // console.log({ order_shop });
  const dispatch = useDispatch();
  const { pickup_addresses } = useSelector((state) => state.options);
  const ordersShipmentsOver80Kg = useSelector(
    (state) => state.orders.ordersShipmentsOver80Kg
  );
  const or_quantity_manual = useSelector(
    (state) => state.orders.or_quantity_manual
  );
  const [action, setAction] = useState("creating");
  const [selectedCarrier, setSelectedCarrier] = useState("sendDirectly");
  const [activeKey, setActiveKey] = useState([2]);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("dpd");
  const [delivery, setDelivery] = useState("dpd_b2c");
  const [address, setAddress] = useState({
    ...defaultAddress,
    ...shipping_address,
  });
  const [general, setGeneral] = useState(defaultGeneral);
  //
  const [errors, setErrors] = useState({});
  const [isSkipLabel, setIsSkipLabel] = React.useState(false);
  const [savedAddress, setSavedAddress] = useState({
    ...defaultAddress,
    ...shipping_address,
  });
  const [showCodError, setShowCodError] = useState(false);
  const [showCarryingError, setShowCarryingError] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [prevCodEnabled, setPrevCodEnabled] = useState(false);
  const [productTransferData, setProductTransferData] = useState(null);
  // New label: products are moved from the replaced shipment
  const replaceRows = replaceShipment
    ? (replaceShipment.shipment_order_rows || []).filter(
      (e) => !e.canceled_at && !e.deleted_at
    )
    : null;

  useEffect(() => {
    const fetchProductTransferData = async () => {
      if (form_type === "ProductTransfer" && id) {
        try {
          const response = await Axios.get(`/api/v1/product_transfers/${id}`);
          setProductTransferData(response.data);

          if (response.data?.receiver?.pickup_address) {
            const pickupAddr = response.data.receiver.pickup_address;
            setAddress({
              firstname: pickupAddr.company || '',
              lastname: pickupAddr.contact_person || '',
              postal_code: pickupAddr.postal_code || '',
              street: pickupAddr.address || '',
              city: pickupAddr.city || '',
              phone: pickupAddr.phone || '',
              other: pickupAddr.email || '',
              comment: pickupAddr.comment || '',
              country_id: pickupAddr.country_id,
              parcel_terminal_id: undefined,
            });
          }
        } catch (error) {
          console.error("Failed to fetch ProductTransfer data:", error);
        }
      }
    };

    fetchProductTransferData();
  }, [form_type, id]);

  useEffect(() => {

    if (action === "created" && responseData) {
      setPrevCodEnabled(general.cod);

      if (form_type === "ProductTransfer") {
        return;
      }

      const fillDataFromCallback = () => {
        const { shipment } = responseData;

        const hasUnshippedRows = order_rows.some(row =>
          !responseData.order_rows.find(r =>
            r.id === row.id && r.disabled_at
          )
        );

        const shouldKeepCod = prevCodEnabled && hasUnshippedRows;


        setAddress({
          firstname: shipment.shipment_address.name.split(' ')[0] || '',
          lastname: shipment.shipment_address.name.split(' ').slice(1).join(' ') || '',
          postal_code: shipment.shipment_address.postal_code,
          street: shipment.shipment_address.address,
          city: shipment.shipment_address.city,
          phone: shipment.shipment_address.phone,
          other: shipment.shipment_address.email,
          comment: shipment.shipment_address.comment,
          country_id: shipment.shipment_address.country_id,
          parcel_terminal_id: shipment.shipment_address.parcel_terminal_id
        });

        const additionalServices = shipment.shipment_additional_services.reduce((acc, service) => {
          acc[service.service_key] = service.service_value;
          return acc;
        }, {});

        setGeneral({
          ...defaultGeneral,
          weight: additionalServices.weight || 1,
          pack: additionalServices.pack || 1,
          cod: prevCodEnabled || additionalServices.cod === 'true',
          order_return: additionalServices.order_return === 'true',
          deliveryOnSaturday: additionalServices.sat === 'true',
          delivery_same_day: additionalServices.delivery_same_day === 'true',
          sendingDocuments: additionalServices.docret === 'true',
          carrying: additionalServices.carrying === 'true',
          swap: additionalServices.swap === 'true',
          suppliers: shipment.pickup_address_id
        });

        const finalShipmentType = shipment.shipment_type === "posti" ? "itella" : shipment.shipment_type;
        const finalDelivery = (additionalServices.delivery || 'dpd').includes("posti")
          ? (additionalServices.delivery || 'dpd').replace("posti", "itella")
          : (additionalServices.delivery || 'dpd');

        setType(finalShipmentType);
        setDelivery(finalDelivery);

        setSelectedCarrier(shipment.final_carrier || 'sendDirectly');
      };

      fillDataFromCallback();
    }
  }, [action, responseData]);

  useEffect(() => {
    if (selectedCarrier !== "sendDirectly") {
      setShowCodError(general.cod);
      setShowCarryingError(general.carrying);
    } else {
      setShowCodError(false);
      setShowCarryingError(false);
    }
  }, [selectedCarrier, general.cod, general.carrying]);

  useEffect(() => {
    if (replaceShipment) {
      const values = shipmentToFormValues(replaceShipment);
      // Warehouse (Also, Adrem...) already received the order - send new label from office
      const office = isWarehousePickupAddress(replaceShipment.pickup_address)
        ? findOfficePickupAddress(pickup_addresses)
        : null;
      setType(values.type);
      setDelivery(values.delivery);
      setAddress(values.address);
      setSavedAddress(values.address);
      setSelectedCarrier(values.selectedCarrier);
      setGeneral({
        ...defaultGeneral,
        ...values.general,
        suppliers: office ? office.id : values.general.suppliers,
      });
      dispatch(setParcelTerminalsOptions());
      dispatch(setPickupAddressesOptions());
      return;
    }
    const values = setOrderInitialValue(
      {
        carrier,
        shipments,
        leasing_cod,
        shipping_address,
        billing_address,
        waiting_payments,
        payment_module,
        order_cart_rules,
        remark,
        id,
      },
      {
        order_rows,
        pickup_addresses,
      }
    );

    const finalOrderType = values.order_type === "posti" ? "itella" : values.order_type;
    const finalDelivery = values.delivery && values.delivery.includes("posti")
      ? values.delivery.replace("posti", "itella")
      : values.delivery;

    setType(finalOrderType);
    setDelivery(finalDelivery);

    if (form_type !== "ProductTransfer") {
      setAddress(values.shipping_address_edit);
    }

    setGeneral((prev) => ({
      ...prev,
      carrying: values.carrying,
      cod: prev.cod !== undefined && prev.cod !== defaultGeneral.cod ? prev.cod : (prevCodEnabled || values.cod),
      cod_amount: values.cod_amount,
      suppliers: pickup_address_id || carrier?.pickup_address_id,
    }));
    //

    dispatch(setParcelTerminalsOptions());
    dispatch(setPickupAddressesOptions());
  }, [action, pickup_addresses.length]);

  useEffect(() => {
    if (form_type === "ProductTransfer" && (pickup_address_id || carrier?.pickup_address_id)) {
      setGeneral((prev) => ({
        ...prev,
        suppliers: pickup_address_id || carrier?.pickup_address_id,
      }));
    }
  }, [form_type, pickup_address_id, carrier?.pickup_address_id]);

  useEffect(() => {
    if (replaceShipment) return;
    setGeneral((prev) => ({
      ...prev,
      cod: setCod({
        cod,
        leasing_cod,
        shipment_type: type,
        payment_module,
      }),
    }));
  }, [type, cod, leasing_cod]);

  useEffect(() => {
    if (!general.cod || replaceShipment) return;
    setGeneral((prev) => ({
      ...prev,
      cod_amount: setCodAmount2({
        waiting_payments,
        order_rows,
        or_quantity_manual,
        shipments,
        orderInfo: {
          total_shipping_tax_incl,
          leasing_cod,
          leasing_advance,
        },
        order_cart_rules,
      }).price,
    }));
  }, [general.cod, order_rows, or_quantity_manual, order_cart_rules]);

  const matchesService = (orderRows) => {
    return orderRows?.some((row) => {
      return servicesKeywords?.some((keyword) => {
        return row.product_name?.includes(keyword);
      });
    });
  };

  const hasMatchingService = matchesService(order_rows);

  const onChangeAddress = (e, mass) => {
    if (mass) {
      return setAddress({
        ...address,
        ...e,
      });
    }
    const { value, name } = e.target;
    setAddress({
      ...address,
      [name]: value,
    });
  };

  const onChangeGeneral = (e) => {
    const { value, name } = e.target;
    setGeneral((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onChangeType = (new_type) => {
    const finalType = new_type === "posti" ? "itella" : new_type;

    const {
      cod,
      delivery,
      deliveryOnSaturday,
      delivery_same_day,
      deliveryTime,
      deliveryTimeHours,
      pack,
      sendingDocuments,
      shipping_address_edit,
      swap,
      terminalSelected,
      weight,
      who,
    } = handleChangeOrdertypeGlobal(
      finalType,
      type,
      { ...address },
      { ...billing_address, comment: address.comment },
      general.cod,
      carrier
    );
    setGeneral((prev) => ({
      ...prev,
      cod,
      deliveryOnSaturday,
      delivery_same_day,
      deliveryTime,
      deliveryTimeHours,
      pack,
      sendingDocuments,
      swap,
      weight,
      who,
    }));
    setDelivery(delivery);
    setType(finalType);
    setAddress({
      ...shipping_address_edit,
      parcel_terminal_id: terminalSelected,
    });
  };

  const onChangeDelivery = (name) => {
    const { delivery, pack, swap, terminalSelected } =
      onChangeCheckBoxDeliveryGlobal({ target: { name } }, delivery);

    setAddress({
      ...address,
      parcel_terminal_id: terminalSelected ?? address.parcel_terminal_id,
    });
    setGeneral((prev) => ({
      ...prev,
      pack,
      swap,
    }));
    setDelivery(delivery);
  };

  const createShipping = async () => {
    if (
      !replaceShipment &&
      order_shop?.identifier == "TCH" &&
      type == "at_the_store" &&
      order_rows.filter((e) => e.selected).length == 0
    ) {
      return antdMessageError(
        "[TCH] Cannot be created without a product selected"
      );
    }
    setLoading(true);

    const { weight, pack: packets, suppliers } = general;
    const {
      parcel_terminal_id,
      firstname,
      lastname,
      postal_code,
      street,
      country_id,
      country,
      city,
      phone,
      other,
      comment,
    } = address;
    let orderVariables = {
      id_order,
      tr_request_item_ids: Array.isArray(multiple)
        ? multiple
          .filter(
            (multi) =>
              order_rows.filter(
                (e) => e.selected && multi.order_row_id == e.id
              ).length > 0
          )
          .map((d) => d.tr_request_item_id)
        : null,
      order_ids: Array.isArray(multiple)
        ? multiple
          .filter(
            (multi) =>
              order_rows.filter(
                (e) => e.selected && multi.order_row_id == e.id
              ).length > 0
          )
          .map((d) => d.order_id)
        : null,
      shipment: {
        shipment_type: shipment_type_setter(type, delivery),
        packets: packets || 1,
        weight: weight,
        pickup_address_id: suppliers,
        skip_labels: isSkipLabel,
        shipment_address_attributes: {
          company: "",
          name: firstname + " " + lastname,
          address: street,
          country_id,
          city,
          postal_code,
          parcel_terminal_id,
          phone: phone?.trim(),
          email: other,
          comment,
        },
        shipment_order_rows_attributes: replaceRows
          ? replaceRows.map((e) => ({
            quantity: e.quantity,
            title: e.title || e.order_row?.product_name,
            price: e.price || e.order_row?.unit_price_tax_incl,
            order_row_id: e.order_row_id,
          }))
          : order_rows
            .filter((e) => e.selected)
            .map((e) => ({
              quantity: or_quantity_manual[e.id] || +e?.quantity,
              title: e.product_name,
              price: e.unit_price_tax_incl,
              order_row_id: e.id,
            })),

        shipment_additional_services_attributes:
          shipmentAdditionalServicesAttributesParams({
            ...general,
            packets,
            delivery,
            type,
            shipping_price: possibilityToAssignDeliveryAmount({
              shipments,
              orderInfo: {
                total_shipping_tax_incl,
              },
            }),
            cod_rules: setCodAmount2({
              waiting_payments,
              order_rows,
              or_quantity_manual,
              shipments,
              orderInfo: {
                total_shipping_tax_incl,
                leasing_cod,
                leasing_advance,
              },
              order_cart_rules,
            }),
          }),
      },
      final_carrier: selectedCarrier,
    };
    if (replaceShipment) orderVariables.replace_shipment_id = replaceShipment.id;

    const proceedWithShipping = () => {
      if (availableCountries(country_id, order_shop.country_id)) {
        return createShippingApi(orderVariables);
      }
      AntdConfirm({
        title: (
          <span>
            Are you sure you want to ship to this country:{" "}
            <b>{country?.en_name}</b>?
          </span>
        ),
        onOk: () => createShippingApi(orderVariables),
        onCancel: () => setLoading(false),
      });
    };

    if (type === "zipasgo" && suppliers) {
      const supplierInfo = pickup_addresses.find((pa) => pa.id === suppliers);
      AntdConfirm({
        title: (
          <span>
            Are you sure you want to create a shipment with <b>ZipasGo</b> courier from supplier{" "}
            <b>{supplierInfo?.label || suppliers}</b>?
          </span>
        ),
        onOk: () => proceedWithShipping(),
        onCancel: () => setLoading(false),
      });
      return;
    }

    proceedWithShipping();
  };

  const createShippingApi = async (orderVariables) => {
    try {
      const res = await dispatch(
        postOrderShipping(id, orderVariables, form_type)
      );

      if (res.success) {
        setErrors({});
        if (replaceShipment) return callBackOnCreate(id, res.data);
        setResponseData(res.data);
        if (!multiple) {
          setAction("created");
          setTimeout(() => {
            setAction("creating");
          }, 500);
        }
        callBackOnCreate(id, res.data);
      } else {
        setErrors(res.errors);
      }
    } catch (err) {
      console.error("[ShipmentComponentIndex] createShippingApi error:", err);
    } finally {
      setLoading(false);
    }
  };

  const createNewShipping = () => {
    setAction("creating");
    setActiveKey([1, 2]);
    setType("dpd");
    setDelivery("dpd_b2c");
    setAddress(defaultAddress);
    setGeneral(defaultGeneral);
    setErrors({});
    setLoading(false);
  };

  const collapseBlock = (item) => {
    let allActives = [...activeKey];
    if (allActives.includes(item)) {
      allActives = allActives.filter((e) => e != item);
    } else {
      allActives.push(item);
    }
    setActiveKey(allActives);
  };

  if (action == "created") {
    return <SuccessCreated createNewShipping={createNewShipping} />;
  }

  const onChangeCarrier = (carrier) => {
    setSelectedCarrier(carrier);
    if (carrier === "sendDirectly") {
      setAddress(savedAddress);
    } else {
      setSavedAddress(address);
      setAddress({
        ...ordersShipmentsOver80Kg[carrier],
        firstname: ordersShipmentsOver80Kg[carrier].name,
        lastname: "",
        country_id: ordersShipmentsOver80Kg[carrier].country_id,
        street: ordersShipmentsOver80Kg[carrier].address,
      });
    }
  };

  const areAllRowsDisabled = (rows) => {
    if (!rows || rows.length === 0) return false;
    return !rows.some(row => !row.disabled_at);
  };

  // MAIN
  return (
    <>
      <div
        className="py-2"
        style={{
          width: 400,
          backgroundColor: "#fff",
        }}
      >
        <div className="col-12">
          <span className="font-weight-bold d-block modal-title text-orange mb-2">
            <span className="font-weight-bold text-black small">
              {replaceShipment ? "New label" : "Shipments"}
            </span>
            <button type="button" className="close" onClick={onClose}>
              <span aria-hidden="true">×</span>
            </button>
          </span>
        </div>
        <div className="col-12">
          <div className="d-flex flex-wrap minus-margin">
            {shipment_types_options.filter(
              option => !["matkahuolto", "posti"].includes(option.value)
            ).map((e) => {
              return (
                <div
                  key={e.value}
                  className={`d-flex align-items-center justify-content-center cursor-pointer mx-1
            ${e.value === type
                      ? "border-orange bg-white border"
                      : "bg-silver-light"
                    }
            `}
                  style={{
                    width: "30%",
                    minHeight: 35,
                    borderRadius: 2,
                    borderWidth: 0.5,
                    marginBottom: 5,
                  }}
                  onClick={() => onChangeType(e.value)}
                >
                  {renderTextInBlock(e)}
                </div>
              )
            })}
            {form_type === "ProductTransfer" && (
              <div
                key="vv_transport"
                className={`d-flex align-items-center justify-content-center cursor-pointer mx-1
                  ${type === "vv_transport"
                    ? "border-orange bg-white border"
                    : "bg-silver-light"
                  }
                `}
                style={{
                  width: "30%",
                  minHeight: 35,
                  borderRadius: 2,
                  borderWidth: 0.5,
                  marginBottom: 5,
                }}
                onClick={() => onChangeType("vv_transport")}
              >
                <span className="text-xs">VV transport</span>
              </div>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="border-bottom py-1">
            <div
              className="d-flex justify-content-between align-items-center cursor-pointer"
              onClick={() => collapseBlock(1)}
            >
              <div
                className="text-black font-weight-bold"
                style={{ fontSize: 14, letterSpacing: "0.4px" }}
              >
                Address
              </div>
              {activeKey.includes(1) ? (
                <MdKeyboardArrowUp color="#707070" size={18} />
              ) : (
                <MdKeyboardArrowDown color="#707070" size={18} />
              )}
            </div>
            {activeKey.includes(1) && (
              <RenderAddress
                delivery={delivery}
                onChangeDelivery={onChangeDelivery}
                type={type}
                address={address}
                onChangeAddress={onChangeAddress}
                setSelectedCarrier={setSelectedCarrier}
                selectedCarrier={selectedCarrier}
                carrying={hasMatchingService}
                onChangeCarrier={onChangeCarrier}
                form_type={form_type}
              />
            )}
          </div>
        </div>
        <div className="col-12 ">
          <div className="border-bottom  py-1">
            <div
              className="d-flex justify-content-between align-items-center cursor-pointer"
              onClick={() => collapseBlock(2)}
            >
              <div
                className="text-black font-weight-bold"
                style={{ fontSize: 14, letterSpacing: "0.4px" }}
              >
                Information
              </div>
              {activeKey.includes(2) ? (
                <MdKeyboardArrowUp color="#707070" size={18} />
              ) : (
                <MdKeyboardArrowDown color="#707070" size={18} />
              )}
            </div>
            {activeKey.includes(2) && (
              <RenderInformation
                key={responseData}
                shop_identifier={order_shop?.identifier}
                form_type={form_type}
                order_rows={order_rows}
                responseData={responseData}
                setResponseData={setResponseData}
                isOrderIndex={true}
                orderRowsChange={orderRowsChange}
                type={type}
                delivery={delivery}
                general={general}
                onChangeGeneral={onChangeGeneral}
                errors={errors}
                order={{ id }}
                country_id={address.country_id}
                cod_details={{
                  waiting_payments,
                  default_cod: leasing_cod ? leasing_advance : total_price || 0,
                }}
                pickup_addresses={pickup_addresses}
                address={address}
                replaceRows={replaceRows}
              />
            )}
          </div>
        </div>
        {!replaceShipment && shipments.length > 0 && (
          <div className="col-12 ">
            <div className="border-bottom  py-1">
              <div
                className="d-flex justify-content-between align-items-center cursor-pointer"
                onClick={() => collapseBlock(3)}
              >
                <div
                  className="text-black font-weight-bold d-flex align-items-center"
                  style={{ fontSize: 14, letterSpacing: "0.4px" }}
                >
                  Shipments{" "}
                  {shipments.filter(
                    (e) =>
                      !e.printed_at &&
                      ["dpd", "lp_express", "omniva"].includes(e.shipment_type)
                  ).length > 0 && (
                      <Tooltip placement="top" title={"Not printed"}>
                        <FiAlertCircle className="text-danger cursor-pointer ml-1" />{" "}
                      </Tooltip>
                    )}
                </div>
                {activeKey.includes(3) ? (
                  <MdKeyboardArrowUp color="#707070" size={18} />
                ) : (
                  <MdKeyboardArrowDown color="#707070" size={18} />
                )}
              </div>
              {activeKey.includes(3) && (
                <RenderShipments shipments={shipments} />
              )}
            </div>
          </div>
        )}
        <div className="col-12">
          <CheckBoxInput
            name={"noLabel"}
            text={"Do not generate label"}
            checked={isSkipLabel}
            onChange={() => setIsSkipLabel(() => !isSkipLabel)}
          />
        </div>
        {showCarryingError && (
          <div className="col-12">
            <div
              style={{
                backgroundColor: "#FFF1F0",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 10,
                padding: 10,
              }}
            >
              <IconCloseCircle />
              <p
                style={{
                  margin: 0,
                  marginLeft: 5,
                  fontSize: 11,
                  lineHeight: "13.2px",
                }}
              >
                The carrying service was unmarked due to non-compliance
              </p>
            </div>
          </div>
        )}
        {showCodError && (
          <div className="col-12">
            <div
              style={{
                backgroundColor: "#FFF1F0",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 10,
                padding: 10,
              }}
            >
              <IconCloseCircle />
              <p
                style={{
                  margin: 0,
                  marginLeft: 5,
                  fontSize: 11,
                  lineHeight: "13.2px",
                }}
              >
                The COD service is not available doe to non-compliance
              </p>
            </div>
          </div>
        )}
        <div className="col-12 d-flex justify-content-between mt-2">
          <div
            style={{
              width: "40%",
            }}
          >
            <DalineSaskaita
              order_id={id}
              order_rows_info={order_rows}
              shipments_info={shipments}
              invoices_info={order_invoices}
              order_cart_rules_info={order_cart_rules}
              carrier_info={carrier}
              assigned_bills_info={assigned_bills}
              order_shop_id={order_shop_id}
            />
          </div>
          <div
            style={{
              width: "40%",
            }}
          >
            <ButtonSecondary
              disabled={
                showCodError ||
                showCarryingError ||
                (replaceRows
                  ? replaceRows.length === 0
                  : areAllRowsDisabled(responseData?.order_rows || order_rows))
              }
              loading={loading}
              onClick={() => createShipping()}
            >
              {replaceShipment
                ? "Create new label"
                : type == "at_the_store"
                  ? "Create a pickup"
                  : "Create a shipment"}
            </ButtonSecondary>
          </div>
        </div>
      </div>
    </>
  );
}

const RenderInformation = ({
  shop_identifier,
  order_rows,
  orderRowsChange,
  type,
  delivery,
  general,
  onChangeGeneral,
  errors,
  cod_details,
  country_id,
  form_type,
  pickup_addresses,
  order,
  responseData,
  setResponseData,
  address,
  replaceRows,
}) => {
  const [adjustedRows, setAdjustedRows] = useState(order_rows);

  useEffect(() => { setAdjustedRows(order_rows) }, [order_rows]);

  useEffect(() => {
    if (!responseData?.order_rows) return;
    setAdjustedRows((prevRows) =>
      prevRows.map((row) => {
        const remoteRow = responseData.order_rows.find((r) => r.id === row.id);
        if (remoteRow && remoteRow.disabled_at && !row.disabled_at) {
          return {
            ...row,
            disabled_at: remoteRow.disabled_at,
            selected: false,
            shipments_count: remoteRow.shipments_count,
            shipment_order_rows: remoteRow.shipment_order_rows,
          };
        }
        return row;
      })
    );
  }, [responseData, order_rows]);

  return (
    <div className="shiping_index_smaller">
      <Divs>
        {replaceRows ? (
          <ReplaceShipmentRows rows={replaceRows} />
        ) : (
          <RowsInShipment
            responseData={responseData}
            form_type={form_type}
            order_rows={adjustedRows}
            orderRowsChange={orderRowsChange}
            setResponseData={setResponseData}
          />
        )}
        <div className="pb-1">
          <SelectForm
            options={
              shop_identifier == "TCH"
                ? pickup_addresses.filter(({ technorama }) => technorama)
                : pickup_addresses
            }
            placeholder={"Supplier"}
            onlyPlaceholder="Choose"
            selector="suppliers"
            value={general.suppliers}
            onChange={(value) =>
              onChangeGeneral({ target: { value, name: "suppliers" } })
            }
            error={
              errors?.pickup_address &&
              errors?.pickup_address.map((item) => `${item} `)
            }
          />
        </div>
        <ShipmentAdditionalServices
          order_rows={order_rows}
          cod_details={cod_details}
          order_type={type}
          delivery={delivery}
          variables={general}
          handleChangeText={onChangeGeneral}
          errors={errors}
          country_id={country_id}
          order={order}
          address={address}
        />
      </Divs>
    </div>
  );
};

const ReplaceShipmentRows = ({ rows }) => (
  <div className="pb-2" style={{ fontSize: 13 }}>
    <div className="text-black font-weight-bold mb-1">Order goods</div>
    {rows.map((e) => (
      <p className="mb-0" key={e.id}>
        <span className="font-weight-bold pr-1">
          {e.quantity || Math.floor(e.order_row?.quantity)}*
        </span>
        {e.order_row?.product_name || e.title || e.order_row_id}
      </p>
    ))}
  </div>
);

const RenderAddress = ({
  delivery,
  onChangeDelivery,
  type,
  address,
  onChangeAddress,
  selectedCarrier,
  onChangeCarrier,
  carrying,
  form_type,
}) => {
  const dispatch = useDispatch();
  const { countries } = useSelector((state) => state.options);

  const shipment_rule = shipmentTypeRules(type);
  const onChangeParcelTerminal = useCallback(
    (value) =>
      onChangeAddress({ target: { name: "parcel_terminal_id", value } }),
    []
  );

  useEffect(() => {
    dispatch(setCountriesOptions());
  }, []);

  return (
    <Divs className="shiping_index_smaller">
      <div className="row">
        <div className="col-12">
          {shipment_rule.deliveries.map(({ value, label }) => {
            return (
              <CheckBoxInput
                key={value}
                name={value}
                text={label}
                checked={delivery == value}
                onChange={() => onChangeDelivery(value)}
              />
            );
          })}
        </div>
        {(carrying || form_type === "ProductTransfer") && (
          <div className="col-12 row">
            {(address.country_id === 122 || form_type === "ProductTransfer") && (
              <div className="col-6">
                <CheckBoxInput
                  name={"siuntu_pilotai"}
                  text={"Siuntų pilotai"}
                  type="radio"
                  checked={selectedCarrier === "siuntu_pilotai"}
                  onChange={() => onChangeCarrier("siuntu_pilotai")}
                />
              </div>

            )}
            {form_type === "ProductTransfer" && (
              <div className="col-6">
                <CheckBoxInput
                  name={"other_carrier"}
                  text={"Other Carrier"}
                  type="radio"
                  checked={selectedCarrier === "other_carrier"}
                  onChange={() => onChangeCarrier("other_carrier")}
                />
              </div>

            )}
            {address.country_id === 115 && (
              <div className="col-6">
                <CheckBoxInput
                  name={"avector"}
                  text={"Avector"}
                  type="radio"
                  checked={selectedCarrier === "avector"}
                  onChange={() => onChangeCarrier("avector")}
                />
              </div>
            )}
            {address.country_id === 51 && (
              <div className="col-6">
                <CheckBoxInput
                  name={"adduco"}
                  text={"Adduco"}
                  type="radio"
                  checked={selectedCarrier === "adduco"}
                  onChange={() => onChangeCarrier("adduco")}
                />
              </div>
            )}
            <div className="col-6">
              <CheckBoxInput
                name={"sendDirectly"}
                text={"Siųsti tiesiogiai"}
                type="radio"
                checked={selectedCarrier === "sendDirectly"}
                onChange={() => onChangeCarrier("sendDirectly")}
              />
            </div>
          </div>
        )}
        <div className="col-6">
          <TextInputModal
            text="Recipient"
            placeholder="Enter"
            name="firstname"
            value={address.firstname}
            onChange={onChangeAddress}
          />
        </div>
        <div className="col-6">
          <TextInputModal
            text="Contact person"
            placeholder="Enter"
            name="lastname"
            value={address.lastname}
            onChange={onChangeAddress}
          />
        </div>
        <div className="col-6">
          <SelectForm
            options={countries?.map((e) => ({
              value: e.id,
              label: e.en_name,
            }))}
            placeholder="Country"
            onlyPlaceholder="Choose"
            value={address.country_id}
            disabled={selectedCarrier !== "sendDirectly"}
            onChange={(value) => {
              onChangeAddress(
                {
                  country_id: value,
                  parcel_terminal_id: null,
                },
                true
              );
            }}
          />
        </div>
        <div className="col-6">
          <TextInputModal
            text="Address"
            placeholder="Enter"
            name="street"
            value={address.street}
            onChange={onChangeAddress}
          />
        </div>
        {show_parcels(type, delivery) && (
          <div className="col-6">
            <SelectParcelTerminalInput
              label="Parcel terminal"
              value={address.parcel_terminal_id}
              shipment_type={type}
              delivery={delivery}
              country_id={address.country_id}
              onChange={onChangeParcelTerminal}
            />
          </div>
        )}
        <div className="col-6">
          <TextInputModal
            text="City"
            placeholder="Enter"
            name="city"
            value={address.city}
            onChange={onChangeAddress}
          />
        </div>
        <div className="col-6">
          <TextInputModal
            text="Postal code"
            placeholder="Enter"
            name="postal_code"
            value={address.postal_code}
            onChange={onChangeAddress}
          />
        </div>
        <div className="col-6">
          <TextInputModal
            text="Phone"
            placeholder="Enter"
            name="phone"
            value={address.phone}
            onChange={onChangeAddress}
          />
        </div>
        <div className="col-6">
          <TextInputModal
            text="Email"
            placeholder="Enter"
            name="other"
            value={address.other}
            onChange={onChangeAddress}
          />
        </div>
        <div className="col-6">
          <TextInputModal
            text="Note from client"
            placeholder="Enter"
            name="comment"
            value={address.comment}
            onChange={onChangeAddress}
          />
        </div>
      </div>
    </Divs>
  );
};

const RenderShipments = ({ shipments }) => {
  return (
    <div className="shiping_index_smaller">
      <div className="border-bottom  py-1">
        <table className="table mb-4">
          <tbody>
            {shipments
              .sort((a, b) => (a.id < b.id ? 1 : -1))
              .map((e) => (
                <ShippmentTable mode="create_index" key={e.id} item={e} />
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const SuccessCreated = ({ createNewShipping }) => {
  return (
    <div
      style={{
        width: 400,
        // minHeight: 500,
      }}
    >
      <div className="d-flex align-items-center justify-content-center">
        <FcCheckmark />
        <p className="mb-0 ml-2">Successfully created!</p>
        <div className="float-right ml-3">
          <ClassicButton
            loading={false}
            text={"Pildyti naują formą"}
            onClick={() => createNewShipping()}
          />
        </div>
      </div>
    </div>
  );
};
